// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Subject.part-type-switcher[data-v-dab18baa]{margin:0}.Subject[data-v-dab18baa]{text-align:left;padding:.625rem;font-weight:700}body[dir=rtl] .Subject[data-v-dab18baa]{text-align:right}.Subject p[data-v-dab18baa]{margin:0}@media only screen and (min-width:1024px)and (max-width:1439px){.sidebar-open .Subject[data-v-dab18baa]{padding:.3125rem}}", ""]);
// Exports
module.exports = exports;
